import { AssetUrlProps } from '@cld/code-snippet-next';
import { removeFileExtension } from './removeFileExtension';

/**
 * Map AssetUrlProps to URL search params supported by Transformation Builder
 * @example
 * // returns "kind=video&transformationString=e_sepia&publicId=dog
 * buildTransformationBuilderUrlParams({ kind: "upload/video", transformation: "e_sepia", publicId: "dog" })
 */
export const buildTransformationBuilderUrlParams = (assetUrl: AssetUrlProps) => {
  const { kind = '', transformation = '', publicId = '' } = assetUrl;

  const params = new URLSearchParams();
  if (kind.includes('video')) {
    params.append('mediaType', 'video'); // only set media type for video, image is always default
  }

  if (transformation !== '') {
    params.append('transformationString', trailSlashes(transformation));
  }

  if (publicId !== '') {
    params.append('publicId', removeFileExtension(publicId));
  }

  return params.toString();
};

const trailSlashes = (s: string) => s.replace(/^\/|\/$/g, '');
